module.exports = __webpack_public_path__ + "img/sansuo.efcd4507.png";